import React, { useMemo, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Card from "../../../../components/cards/admin/cards";
import Table from "../../../../components/tables/tableCols1";
import TableSkeleton from "../../../../components/skeleton/table";
import Button from "../../../../components/buttons/buttons";
import { Beat } from "../../../../plugins/spinners.plugin";
import { writeFileWithXLSX } from "../../../../components/exports/xlsx";
import { Pagination } from "../../../../components/pagination/pagination";
import EmptyState from "../../../../assets/images/emptyState/food-package.svg";
import { AllFiltersModal } from "../../../../components/modals/allFiltersModal";
import FilterMerchPackageItemDropDown from "../../../../components/dropDown/filter/filterMerchItem";
import {
  searchSubscriptionMerchAction,
  filterSubscriptionMerchAction,
  getAllSubscriptionMerchNoPagination,
} from "../../../../redux/subscriptionMerchandise/subscriptionMerchAction";
import subscriptionType from "../../../../redux/subscriptionMerchandise/subscriptionMerchTypes";

function numberWithCommas(x) {
  return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default function Items() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { page } = useParams();
  const [data, setData] = useState([]);
  const [isFilterOpen, setFilterState] = useState(false);
  let { isLoading, searching, filtering } = useSelector(
    (state) => state.subscriptionMerch
  );
  let { allSubscriptionMerchs, downloading } = useSelector(
    (state) => state.subscriptionMerch
  );
  const [input, setInput] = useState({
    search: "",
  });

  let lastMonth = new Date();
  lastMonth.setDate(lastMonth.getDate() - 30);

  const [payLoad] = useState({
    start_date: lastMonth,
    end_date: new Date(),
  });

  useEffect(() => {
    dispatch(filterSubscriptionMerchAction(payLoad, page));
    // eslint-disable-next-line
  }, []);

  function createTableData(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((merchandise, index) => {
        let show = {
          id: index + 1,
          price: (
            <span>NGN {numberWithCommas(merchandise?.merchandise_amount)}</span>
          ),
          name: merchandise?.merchandise_name,
          status: merchandise?.merchandise_operating_status,
          created: (
            <span>{moment(merchandise?.created_at).format("MMM D, YYYY")}</span>
          ),
          packageItem: merchandise,
        };
        outputArray.push({ show });
        return true;
      });
      return outputArray;
    }
  }

  function createTableDataDownload(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((merchandise, index) => {
        let show = {
          id: index + 1,
          price: merchandise?.merchandise_amount,
          name: merchandise?.merchandise_name,
          status: merchandise?.merchandise_operating_status,
          created: moment(merchandise?.created_at).format("MMM D, YYYY"),
        };
        outputArray.push(show);
        return true;
      });
      return outputArray;
    }
  }

  useEffect(() => {
    const dataSet = createTableData(allSubscriptionMerchs?.data);
    setData(dataSet);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allSubscriptionMerchs]);

  function goToSinglePage(params) {
    let id = params?.show?.packageItem?.id;
    navigate(`/admin/merchandise-packages/item/${id}`);
  }
  function goToCreatePage() {
    navigate(`/admin/merchandise-packages/item/create`);
  }

  const handleDownload = async () => {
    const response = await dispatch(
      getAllSubscriptionMerchNoPagination({
        ...payLoad,
        pagination: 0,
      })
    );
    if (response) {
      const newData = createTableDataDownload(response?.data);
      writeFileWithXLSX(newData, {
        filename: "Merchandise_package_items.xlsx",
        download: true,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setInput({ ...input, [name]: value });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      doSearch();
    }
  };

  const showSearch = (search) => {
    let dataSet = createTableData(search);
    setData(dataSet);
  };

  const removeSearch = () => {
    if (input?.search?.length === 0) {
      let dataSet = createTableData(allSubscriptionMerchs?.data);
      setData(dataSet);
    }
    dispatch({
      type: subscriptionType["SEARCH_MERCHANDISE_SUBSCRIPTIONS"],
      payLoad: { data: [] },
    });
  };

  async function doSearch() {
    try {
      let response = await dispatch(searchSubscriptionMerchAction(input));
      if (response?.status === "success") {
        showSearch(response?.data);
      }
      if (!response?.status) {
        showSearch([]);
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (input?.search?.length === 0) {
      removeSearch();
    }
    // eslint-disable-next-line
  }, [input, dispatch]);

  const columns = useMemo(
    () => [
      {
        Header: "",
        hideHeader: false,
        id: "checkbox-table-column",
        // First group columns
        columns: [
          {
            Header: "S/N",
            accessor: "show.id",
          },
          {
            Header: "Item",
            accessor: "show.name",
          },
          {
            Header: "Price",
            accessor: "show.price",
          },

          {
            Header: "Status",
            accessor: "show.status",
          },
          {
            Header: "Date Created",
            accessor: "show.created",
          },
        ],
      },
    ],
    []
  );
  return (
    <div data-test="items-page">
      <Card.TableFilter
        title={"Merchandise Package Items"}
        onChange={handleChange}
        handleKeyDown={handleKeyDown}
        searchPlaceholder={"Item Name, Store"}
        filter={
          <AllFiltersModal
            isFilterOpen={isFilterOpen}
            setFilterState={setFilterState}
          >
            <FilterMerchPackageItemDropDown
              isFilterOpen={isFilterOpen}
              setFilterState={setFilterState}
              payLoad={payLoad}
            />
          </AllFiltersModal>
        }
      >
        <Button.Primary
          title={"+ Create New Package Item"}
          onClick={goToCreatePage}
        />

        <Button.Secondary
          title={downloading ? <Beat color={"#CE2600"} /> : "Download CSV"}
          type="button"
          disabled={!data}
          onClick={handleDownload}
        />
      </Card.TableFilter>

      <div className="border-b border-[#E4E4F3]"></div>

      <div className="bg-white rounded-md py-4">
        {isLoading || searching || filtering ? (
          <TableSkeleton />
        ) : data?.length > 0 ? (
          <Table
            columns={columns}
            data={data?.length > 0 ? data : []}
            onClick={goToSinglePage}
            className="w-full"
            rowClass="hover:shadow-md cursor-pointer"
          />
        ) : (
          <div className="py-36 text-center">
            <div className="flex justify-center">
              <img src={EmptyState} className="w-auto" alt="no data" />
            </div>
            <h3 className="mt-5 text-xl font-bold">Package Items</h3>
            <p className="mt-2 text-sm text-[#9CA3AF]">
              You have not added any package items yet.
            </p>
          </div>
        )}
      </div>

      <Pagination
        data={allSubscriptionMerchs}
        route={"admin/merchandise-packages/items"}
      />
    </div>
  );
}
